export default __webpack_public_path__ + "static/assets/d6f44dd7136e86d27730830b54e8f9fd.png";